import { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import OtpInput from 'react-otp-input'
import Modal from '../../Unknown/Modal'
import translate from '../../../i18n/translate'

type Props = {
  visible: boolean
  title: React.ReactNode
  description?: React.ReactNode
  onClose: () => void
  onConfirm: (code: string) => Promise<void> | void
  onResend?: () => Promise<void> | void
  isConfirming?: boolean
  isResending?: boolean
  numDigits?: number
  autoSubmit?: boolean
  maxWidth?: string
}

export default function ConfirmActionOtpModal({
  visible,
  title,
  description,
  onClose,
  onConfirm,
  onResend,
  isConfirming,
  isResending,
  numDigits = 6,
  autoSubmit = true,
  maxWidth = '440px',
}: Props) {
  const [code, setCode] = useState('')

  useEffect(() => {
    if (visible) setCode('')
  }, [visible])

  const handleChange = (nextOtp: string) => {
    setCode(nextOtp)
    if (autoSubmit && nextOtp.length === numDigits && !isConfirming) {
      onConfirm(nextOtp)
    }
  }

  const handleClose = () => {
    setCode('')
    onClose()
  }

  return (
    <Modal
      title={title}
      visible={visible}
      style={{ maxWidth }}
      setVisible={handleClose}
    >
      <Box p={2} display="flex" flexDirection="column" gap={2} alignItems="center">
        {description && (
          <Typography variant="body2" color="textSecondary" textAlign="center">
            {description}
          </Typography>
        )}
        <OtpInput
          value={code}
          onChange={handleChange}
          inputStyle={{ width: '40px', height: '40px', color: 'black', fontSize: '18px' }}
          containerStyle={{ display: 'flex', justifyContent: 'center' }}
          separator={<span style={{ padding: '5px', fontSize: '18px' }}>-</span>}
          isInputNum
          numInputs={numDigits}
        />
        <Box display="flex" gap={1}>
          {onResend && (
            <Button color="warning" variant="outlined" disabled={isResending || isConfirming} onClick={() => onResend()}>
              {isResending ? <CircularProgress size={20} /> : translate('confirmActionOtpResend')}
            </Button>
          )}
          <Button
            color="warning"
            variant="contained"
            disabled={code.length !== numDigits || isConfirming}
            onClick={() => onConfirm(code)}
          >
            {isConfirming ? <CircularProgress size={20} /> : translate('confirmActionOtpConfirm')}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
